// src/hooks/points/usePointsReceipts.js
import React from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
import { asInt } from "../../utils/points/format";

export default function usePointsReceipts(uid) {
  const [loading, setLoading] = React.useState(true);
  const [err, setErr] = React.useState(null);
  const [receipts, setReceipts] = React.useState([]);
  const [pointsTotal, setPointsTotal] = React.useState(0);

  React.useEffect(() => {
    if (!uid) {
      setLoading(false);
      setErr("Please sign in to view your points.");
      setReceipts([]);
      setPointsTotal(0);
      return undefined;
    }

    setLoading(true);
    setErr(null);

    const qRef = query(collection(db, "users", uid, "award_receipts"), orderBy("createdAt", "desc"));

    const unsub = onSnapshot(
      qRef,
      (snap) => {
        const rows = snap.docs.map((d) => ({ id: d.id, ...(d.data() || {}) }));
        let sum = 0;
        rows.forEach((r) => {
          sum += asInt(r.deltaPoints, 0);
        });

        setReceipts(rows);
        setPointsTotal(Math.max(0, sum));
        setLoading(false);
        setErr(null);
      },
      (e) => {
        console.error("award_receipts snapshot error:", e);
        setErr("Could not load your points right now. Please try again.");
        setLoading(false);
      }
    );

    return () => unsub();
  }, [uid]);

  return { loading, err, receipts, pointsTotal };
}
